
import HomeSliders from "./HomeConfig/HomeSliders";
import HomeBrandBanners from "./HomeConfig/HomeBrandBanners";

export default function HomeConfig () {
   
    
    return (
      <div className="admin-page">
        <h1 className="admin-page-title">HOMEPAGE</h1>
          <HomeSliders />
          <HomeBrandBanners />
      </div>
    );
  };
  
  